import { ref } from "vue";
  import * as utils from "@/utils/index";
  export default () => {
    const languageList = ["zh-TW"];
    const pageInfo = {"default":{"title":"标题","ico":""},"zh-TW":{"title":"LINE會員邀請函","ico":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724999700229-64.jpeg"}};

    const languageTxt = {"zh-TW":{"50000":"兌換成功","serverTitle":"伺服器","roleTitle":"角色名","sendCode":"發送驗證碼","hasSend1":"已發送","pleaseSelectServer":"請選擇伺服器","pleaseSelectRole":"請選擇角色","gotoBind":"點擊綁定","noBindText1":"您尚未綁定角色，無法領取獎勵，請","submitSucc":"訂閱成功","-10000":"參數錯誤","-30001":"不能頻繁請求","-20003":"抱歉，當前時間不在活動時間內","-30000":"郵件發送失敗","-20000":"請輸入正確的郵件格式","-20004":"已填寫郵箱地址","-20001":"驗證碼錯誤或已過期，請重新輸入","-20005":"遊戲維護中，無法兌換獎勵","-20006":"伺服器器維護中，無法兌換獎勵","-20007":"角色不存在","common":"系统错误","infoBtn":"活動規則","confirm":"確認","ensure":"確定","roleServer":"您的伺服器","allServer":"全部伺服器","seeAward":"查看獎勵","seeAllAward":"","bindPopupTitle":"綁定角色","copyCode":"複製","getGift":"領取","hasGift":"已領取","pleaseLogin":"请先登入帳號","lineSubTitle":"1.點擊頁面【加入好友】按鈕跳轉LINE進行好友添加\n2. 添加成功後，官方LINE帳號將通過聊天發送添加禮包 \n3. 請複製禮包兌換碼，返回該頁面兌換","inputCodeTitle":"請輸入禮包兌換碼","lineCodeImgSaveTip":"長按儲存二維碼，前往LINE掃碼添加","lineCopySuccTip":"複製成功，請前往LINE添加","lineCodeImgSaveTipWeb":"點擊保存圖片，前往LINE掃碼添加","lineCodeImgSaveTipScreenshot":"截圖保存圖片，前往LINE掃碼添加","lineGuanzhu":"已關注帳號","lineAddFriend":"加入好友","-50001":"兌換碼不存在","-50002":"已完成兌換，不可再兌換","-10012":"序號已過期","-40002":"領獎失敗","-10002":"遊戲維護中，無法兌換獎勵。","-10004":"服務器維護中，無法兌換獎勵。","-10005":"角色不存在","-10006":"虛寶號遊戲不符！","-10007":"領取次數過多","-50007":"此禮包碼已達兌換上限","-10008":"發送失敗，請稍後再試","-10011":"序號無法使用","-10013":"序號已使用或不存在","exchangeNow":"立即兌換","lineTitle":"添加Line官方帳號領取獎勵","logout":"登出帳號","infoCollect":"1.完成關注後，您的LINE賬號將被用於接收LINE官方賬號資訊以及專屬優惠消息；\n2.只有首次關注官方賬號可領取關注禮包，重複關注將不會收到關注禮包，關注禮包兌換有效期：2周內\n3.是否關注遊戲LINE官方賬號，不影響您在遊戲內的其他權益；","lineWelfare":"LINE專屬福利","titleStep1":"STEP1","titleStep2":"STEP2"},"default":{"50000":"","serverTitle":"","roleTitle":"","sendCode":"","hasSend1":"","pleaseSelectServer":"","pleaseSelectRole":"","gotoBind":"","noBindText1":"","submitSucc":"","-10000":"","-30001":"","-20003":"","-30000":"","-20000":"","-20004":"","-20001":"","-20005":"","-20006":"","-20007":"","common":"","infoBtn":"","confirm":"","ensure":"","roleServer":"","allServer":"","seeAward":"","seeAllAward":"","bindPopupTitle":"","copyCode":"","getGift":"","hasGift":"","pleaseLogin":"","lineSubTitle":"","inputCodeTitle":"","lineCodeImgSaveTip":"","lineCopySuccTip":"","lineCodeImgSaveTipWeb":"","lineCodeImgSaveTipScreenshot":"","lineGuanzhu":"","lineAddFriend":"","-50001":"","-50002":"","-10012":"","-40002":"","-10002":"","-10004":"","-10005":"","-10006":"","-10007":"","-50007":"","-10008":"","-10011":"","-10013":"","exchangeNow":"","lineTitle":"","logout":"","infoCollect":"","lineWelfare":"","titleStep1":"","titleStep2":""}};
  
    const getSystemLanguage =  ()=>{
      let res = navigator.language || navigator.userLanguage || navigator.browerLanguage || navigator.systemLanguage;
      if (res.indexOf("-") > -1) {
        const langArr = res.split("-");
        res = langArr[0] === "zh" ? langArr[1] : langArr[0];
      }
      return res.toLowerCase();
    };
    const checkLanguage =  (lang) =>{
      let res = "";
      if (lang) {
        if (lang.indexOf("-") > -1) {
          for (let i = 0; i < languageList.length; i++) {
            if (languageList[i] === lang) {
              res = languageList[i];
            }
          }
        } else {
          const reg = new RegExp(lang, "g");
          for (let i = 0; i < languageList.length; i++) {
            if (reg.test(languageList[i].toLowerCase())) {
              res = languageList[i];
            }
          }
        }
      }
      return res;
    };
    let curLang = checkLanguage(utils.getUrlParams("appLanguage")) || checkLanguage(utils.getUrlParams("language")) || checkLanguage(getSystemLanguage()) || checkLanguage("zh-TW") || "default";
    const initLang = () => {
      document.body.className += " " + curLang;
      document.getElementsByTagName("html")[0].setAttribute("dir", curLang == "ar-SA" ? "rtl" : "ltr");
      
      if(!pageInfo[curLang]) return;
      if(pageInfo[curLang].title){
        document.title = pageInfo[curLang].title;
      }
      if(pageInfo[curLang].ico){
        try{
          document.getElementById("icon").setAttribute("href", pageInfo[curLang].ico);
          document.getElementById("shortcut").setAttribute("href", pageInfo[curLang].ico);
        }catch(e){}
      }
    };

    const getLangTxt = (key,msg)=>{
      let info = languageTxt[curLang] || languageTxt.default;
      return info[key] || String(msg);
    }
  
    return { curLang, initLang, getLangTxt, langData:languageTxt[curLang]||{} };
  };
  